module.exports = __webpack_public_path__ + "static/media/position.711cf1e0.svg";